import { render, staticRenderFns } from "./Czlc.vue?vue&type=template&id=3f588258&scoped=true&"
import script from "./Czlc.vue?vue&type=script&lang=js&"
export * from "./Czlc.vue?vue&type=script&lang=js&"
import style0 from "./Czlc.vue?vue&type=style&index=0&id=3f588258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f588258",
  null
  
)

export default component.exports